const restorePosition = (history, pathname, state) => {
    if (!state || !state.pagePosition) return;

    setTimeout( () => {
        if(!state.positionChanged){
            window.scroll({ top: state.pagePosition, behavior: "auto" });
            history.replace( {
                pathname
            }, { ...state, positionChanged : true } );
        }
    }, 50);
}

export default restorePosition;